import React,{ useEffect } from "react";
import { useAppDispatch, useAppSelector } from "../../../../../../redux/hooks";
import { CustomDetailsList } from "../../../../../common/customDetailsList/customDetailsList";
import { Skeleton } from "../../../../../common/skeleton/skeleton";
import { MasterMerchandiseCategoryFormController } from "../controller/controller";
import { MasterMerchandiseCategoryColumns } from "./column/column";
import { fetchMasterMerchandiseCategoryList } from "../../../../../../redux/actions/resources/master/merchandiseCategory/merchandiseCategory";
interface IMasterMerchandiseCategoryList {
    widthPopUp:any;
    heigthPopUp:any;
}
export const MasterMerchandiseCategoryList:React.FC<IMasterMerchandiseCategoryList> = ({heigthPopUp, widthPopUp}) => {
    const dispatch = useAppDispatch();
    const { loading, list } = useAppSelector((state) => state.masterMerchandiseCategoryList);
    const renderColumns = () => {
        return MasterMerchandiseCategoryColumns();
    };

    useEffect(() => {
        list === undefined && dispatch(fetchMasterMerchandiseCategoryList());
    }, [list]);

    return loading ? (
        <Skeleton rows={5}></Skeleton>
    ) : (
        <>
            <CustomDetailsList
                data={list ?? []}
                renderColumns={renderColumns}
            />
            <MasterMerchandiseCategoryFormController widthPopUp={widthPopUp} heigthPopUp={heigthPopUp}/>
        </>
    );
};
